/**
 * @description 地图扩展 label 组件
 * @todo 待后续 vchart 整体稳定后再拆出
 */
export * from './component';
export * from './interface';
